/**
 * An {@link Error} thrown by app code due to expected reasons such as invalid inputs. This
 * is to differentiate known exceptions from uncaught ones.
 */
export default class IgirException extends Error {}
